import { render, staticRenderFns } from "./TypedepiecesNews.vue?vue&type=template&id=19353280&"
import script from "./TypedepiecesNews.vue?vue&type=script&lang=js&"
export * from "./TypedepiecesNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports